import React, { useState } from 'react';
import './Sorter.css';
import { ApiSortDirection } from '../api/models';

interface Props {
  attribute: string;
  sortAttribute: string;
  sortDirection: ApiSortDirection;
  onSort: (sortAttribute: string, direction: ApiSortDirection) => void;
}

const Sorter = ({ attribute, sortAttribute, sortDirection, onSort }: Props) => {
  const [direction, setDirection] = useState(sortDirection);

  const handleClick = () => {
    if (direction === ApiSortDirection.DESC) {
      setDirection(ApiSortDirection.ASC);
      onSort(attribute, ApiSortDirection.ASC);
    } else {
      setDirection(ApiSortDirection.DESC);
      onSort(attribute, ApiSortDirection.DESC);
    }
  };

  return (
    <span
      data-testid='sorter'
      className={
        sortAttribute === attribute
          ? direction === ApiSortDirection.DESC
            ? 'sorter icon-sort-down'
            : 'sorter icon-sort-up'
          : 'sorter icon-sort'
      }
      onClick={handleClick}
    />
  );
};

export default Sorter;
